import { getTelematicPropertyFromEquipmentAndRenderTelematics } from 'react/utils/telematicsUtils';
import StopDetailsModal from 'react/containers/modals/StopDetails';
import { renderComponent } from 'react/utils/renderUtils';

App.Views.RouteDetails = {

    addActionsToGrid: function (routeId) {
        const routeDetailScreen = Monet.Session.RouteDetail.screensList[routeId];
        const activeTab = routeDetailScreen && routeDetailScreen.activeTab;
        if (activeTab === 'routeDetailPRO') {
            const resequenceHistoryGridHandler = new Greenmile.RouteDetail.ResequenceHistoryGrid(routeId);
            resequenceHistoryGridHandler.addActionsToGrid();
        } else {
            const gridStopsHandler = new Greenmile.RouteDetail.GridStops(routeId);
            gridStopsHandler.addActionsToGrid();
        }
    },

    getHeightToTabInformation: function () {

        var storage = new Greenmile.Storage.StoreMapPosition();
        var heightSaved = storage.getHeightTabsRouteDetailFromUser();
        var height;

        if (heightSaved) {

            height = heightSaved.height;

        } else {

            height = Monet.Utils.getHeightDefaultToTab();
            storage.setHeightTabsRouteDetailFromUser(height);

        }

        return height;
    },

    setInformationStopsPosition: function (screenTab) {

        const informationStops = document.querySelector(screenTab + " div.informationStops");

        if (informationStops) {

            const legendsBottomBar = document.querySelector(screenTab + " .bottomBarContainer");
            const tab = document.querySelector(screenTab + " #tabsRouteDetail");
            const tabHeight = tab && tab.style.display !== 'none' ? parseInt(tab.style.height) + 10 : 25;

            if (legendsBottomBar) {
                const leftInfoStops = informationStops.getBoundingClientRect().left;

                if (leftInfoStops <= (legendsBottomBar.offsetWidth + 10)) {
                    informationStops.style.bottom = (legendsBottomBar.offsetHeight + 10 + tabHeight) + 'px';
                    return;
                }

            }

            informationStops.style.bottom = tabHeight + 'px';

        }

    },

    hideTabInformation: function (screenTab, routeId) {

        if (!document.querySelector(screenTab)) return;

        document.querySelector("#panelContainer").style.bottom = '63px';

        var btnHide = document.querySelector(screenTab + " #btnHideGridStop");
        var tab = document.querySelector(screenTab + " #tabsRouteDetail");
        var legendsBottomBar = document.querySelector(screenTab + " .bottomBarContainer");
        var miniPlayer = document.querySelector(screenTab + " div.miniPlayer");
        var resequenceHistory = document.querySelector(screenTab + " div.resequenceHistory");

        if (tab !== null) {
            tab.style.display = "none";
        }

        App.Views.RouteDetails.setInformationStopsPosition(screenTab);

        if (legendsBottomBar) {
            legendsBottomBar.style.bottom = "0px";
        }

        btnHide.style.display = "none";
        miniPlayer.style.display = "block";

        if (resequenceHistory) {
            resequenceHistory.style.display = "block";
        }

        this.adjustHeightMap(routeId);

        new Greenmile.Storage.StoreMapPosition().setShowGridRouteDetailFromUser(false);

    },

    showTabInformation: function (screenTab, routeId) {

        const routeDetailGridHeight = document.querySelector("#tabsRouteDetail").style.height;
        const heightNumber = parseInt(routeDetailGridHeight) + 10;
        const btnHide = document.querySelector(screenTab + " #btnHideGridStop");
        const tab = document.querySelector(screenTab + " #tabsRouteDetail");
        const miniPlayer = document.querySelector(screenTab + " div.miniPlayer");
        const legendsBottomBar = document.querySelector(screenTab + " .bottomBarContainer");

        document.querySelector("#panelContainer").style.bottom = `${heightNumber}px`;

        if (tab) {

            const routeDetailForm = App.Forms[`RouteDetails_${routeId}`];
            const resequenceHistoryForm = App.Forms[`RouteDetails_${routeId}_ResequenceHistory`];

            const routeDetailTable = routeDetailForm.table;
            const routeDetailGridStops = routeDetailForm.gridStops;

            tab.style.display = "block";

            routeDetailTable.resizeCanvas();
            routeDetailTable.invalidate();
            routeDetailGridStops.addFilterBuilder();

            if (resequenceHistoryForm) {
                const resequenceHistoryTable = resequenceHistoryForm.table;
                const resequenceHistoryGrid = resequenceHistoryForm.gridResequenceHistory;
                resequenceHistoryTable.resizeCanvas();
                resequenceHistoryTable.invalidate();
                resequenceHistoryGrid.addFilterBuilder();
                App.Views.RouteDetails.adjustProGridFooter();
            }

        }

        App.Views.RouteDetails.setInformationStopsPosition(screenTab);

        if (legendsBottomBar) {
            legendsBottomBar.style.bottom = `${parseInt(tab.style.height, 10) + 20}px`;
        }

        Greenmile.Map.Utility.removeLayerByKind(Monet.Session.RouteDetail.screensList[routeId].map, ['STOP_SUGGESTIONS']);
        App.Views.RouteDetails.removeGeocodeSuggest(routeId);
        Monet.Session.RouteDetail.screensList[routeId].editingStop = null;
        Monet.Session.RouteDetail.screensList[routeId].isUpdateAutomatic = true;

        btnHide.style.display = "block";
        miniPlayer.style.display = "none";

        this.adjustHeightMap(routeId);

        new Greenmile.Storage.StoreMapPosition().setShowGridRouteDetailFromUser(true);

    },

    getMinHeightRouteDetailsTab: function() {
        const heightTabElement = $("#tabsRouteDetail ul").height() || 0;
        const heightResizeElement = $("#tabsRouteDetail > div.ui-resizable-handle.ui-resizable-n").height() || 0;
        return heightTabElement + heightResizeElement

    },

    addEventListenners: function (routeId) {

        var screenTab = "#routeMaps_" + routeId;

        var btnHide = document.querySelector(screenTab + " #btnHideGridStop");
        var btnShow = document.querySelector(screenTab + " #miniPlayer");
        var btnResequenceHistory = document.querySelector(screenTab + " #resequenceHistory");
        var btnCloseResequenceHistory = document.querySelector(screenTab + " #panelContainer .close");

        var hideTabInformation = function () {
            return App.Views.RouteDetails.hideTabInformation(screenTab, routeId);
        };

        var showTabInformation = function () {
            return App.Views.RouteDetails.showTabInformation(screenTab, routeId);
        };

        var showResequenceHistory = function () {
          const content = document.querySelector(`#routeMaps_${routeId} .containerRouteDetail #panelContainer #routeDetailsModalContent`);
          const panelContainer = content.parentElement;
          panelContainer.setAttribute('class', 'slide');

          const gridHidden = document.querySelector(`#RouteDetails_${routeId} #miniPlayer`).style.display == "block";

          if(gridHidden) {
              panelContainer.style.bottom = '63px';
          } else {
              const routeDetailGridHeight = document.querySelector(`#RouteDetails_${routeId} #tabsRouteDetail`).style.height;
              const heightNumber = parseInt(routeDetailGridHeight) + 10;
              panelContainer.style.bottom = `${heightNumber}px`;
          }

          renderComponent(
            <StopDetailsModal
              routeId = {routeId}
              index = {1}
            />,
            content
          );

        };

        var closeResequenceHistory = function () {
          const panelContainer = document.querySelector(`#routeMaps_${routeId} .containerRouteDetail #panelContainer`);
          panelContainer.setAttribute('class', 'unslide');
          const stopSelection = new Greenmile.RouteDetail.StopSelection(routeId);
          stopSelection.deselectStop();
        }

        var setInformationStopsPosition = function () {
            return App.Views.RouteDetails.setInformationStopsPosition(screenTab);
        };

        if (btnHide) {

            btnHide.removeEventListener("click", hideTabInformation);
            btnHide.addEventListener("click", hideTabInformation);

        }

        if (btnShow) {

            btnShow.removeEventListener("click", showTabInformation);
            btnShow.addEventListener("click", showTabInformation);

        }

        if (btnResequenceHistory) {

            btnResequenceHistory.removeEventListener("click", showResequenceHistory);
            btnResequenceHistory.addEventListener("click", showResequenceHistory);

        }

        if (btnCloseResequenceHistory) {

            btnCloseResequenceHistory.removeEventListener("click", closeResequenceHistory);
            btnCloseResequenceHistory.addEventListener("click", closeResequenceHistory);

        }
        window.addEventListener("resize", setInformationStopsPosition);

    },

    drawLogBook: function (routeId) {

        var selectorChart = "#routeMaps_" + routeId + " #routeDetailChart";
        var sourceData = Monet.Session.RouteDetail.screensList[routeId];
        var hosCollection = sourceData.listHos;
        var logBook = new Greenmile.HoursOfService.LogBookChart(selectorChart, hosCollection, sourceData);

        logBook.drawChart();

    },

    showLogBookAndSummaryInformation: function (routeId, map, action) {

        var callback,
            hosRequests = new Greenmile.HoursOfService.Requests();

        var screenTab = "#routeMaps_" + routeId;
        var selectorSummary = screenTab + " #routeDetailSummaryInformation";
        var selectorChart = "#routeMaps_" + routeId + " #routeDetailChart";

        callback = function (context) {

            return function (hosCollection) {

                if (hosCollection) {

                    var namespaceCollection = Monet.Session.RouteDetail.screensList[routeId];

                    namespaceCollection.listHos = hosCollection;

                    var mapEvents = new Greenmile.HoursOfService.MapEvents(screenTab);
                    var screen = namespaceCollection;
                    var summary = new Greenmile.HoursOfService.SummaryInformation(selectorSummary, hosCollection, screen);

                    mapEvents.drawMarkers(hosCollection, map, false, action);
                    summary.showSummaryInformation();

                    var tabLogBook = document.querySelector(selectorChart);

                    if (tabLogBook && tabLogBook.style.display === 'block') {
                        context.drawLogBook(routeId);
                    }

                }

            };

        }(this);

        hosRequests.getHosByRouteAndExecuteCallbak(routeId, callback);

    },

    getBottomPositionToMap: function (routeId) {

        var tab = document.querySelector('#routeMaps_' + routeId + ' .bottomBarContainer');
        var bottom = parseInt(tab.style.bottom);
        var heightMap = 18;

        if (bottom > 18) {
            heightMap = bottom;
        }

        return heightMap;

    },

    adjustHeightMap: function (routeId) {

        var map = Monet.Session.RouteDetail.screensList[routeId].map;

        var mapContainer = document.querySelector("#routeMaps_" + routeId + " #routeMapContainer_" + routeId);

        if (mapContainer) {
            map.invalidateSize();
        }

    },

    adjustProGridFooter: function () {
        const proDivRight = document.querySelector("#routeDetailPRO .slick-viewport.slick-viewport-top.slick-viewport-right");
        const proDivLeft = document.querySelector("#routeDetailPRO .slick-viewport.slick-viewport-top.slick-viewport-left");
        const footHeight = 55;

        if( proDivRight && proDivLeft ) {
            let rightHeight = parseInt(proDivRight.style.height);
            let leftHeight = parseInt(proDivLeft.style.height);

            proDivRight.style.height = `${rightHeight - footHeight}px`;
            proDivLeft.style.height = `${leftHeight - footHeight}px`;
        }
    },

    adjustStylesToTabInformation: function (routeId) {

        let error = null;

        try {

            let height = this.getHeightToTabInformation();
            const screenTab = "#routeMaps_" + routeId;
            const screenData = Monet.Session.RouteDetail.screensList[routeId];

            const tab = document.querySelector(screenTab + " #tabsRouteDetail");
            const legendsBottomBar = document.querySelector(screenTab + " .bottomBarContainer");
            const hideTab = document.querySelector(screenTab + " div.gridStopsHide");
            const maxHeight = window.innerHeight - 200;
            const minHeight = this.getMinHeightRouteDetailsTab();


            let grid = null;
            let chart = null;
            let summary = null;
            let telematic = null;
            let pro = null;

            if (height > maxHeight) {
                height = maxHeight;
            }

            const renderByTabId = function (tabId) {

                const routeDetailGridHeight = document.querySelector(`#RouteDetails_${routeId} #tabsRouteDetail`).style.height;
                const heightNumber = parseInt(routeDetailGridHeight) + 10;

                document.querySelector(`#RouteDetails_${routeId} #panelContainer`).style.bottom = `${heightNumber}px`;

                Monet.Session.RouteDetail.screensList[routeId].activeTab = tabId;

                if (tabId != "routeDetailPRO" || tabId != "routeDetailGrid") {
                    const proFilterBuilterDiv = document.querySelector(screenTab + ' .resequenceHistory.gridActions.ui-widget-header'),
                        stopsFilterBuilderDiv = document.querySelector(screenTab + ' .stopList.gridActions.ui-widget-header'),
                        gridActionsDiv = document.querySelector(screenTab + ' .gridActions .saveLayout.gridActionDiv'),
                        routeDetailsGridActionsCustomColumnsDiv = document.querySelector(screenTab + ' .gridActions .MonetUIGridActionsButton.RouteDetail'),
                        proGridActionsCustomColumnsDiv = document.querySelector(screenTab + ' .gridActions .MonetUIGridActionsButton.ProactiveRouteOpt');

                    if (proFilterBuilterDiv && proFilterBuilterDiv.style) {
                        proFilterBuilterDiv.style.visibility = 'hidden';
                    }
                    if (stopsFilterBuilderDiv && stopsFilterBuilderDiv.style){
                        stopsFilterBuilderDiv.style.visibility = 'hidden';
                    }
                    if (gridActionsDiv && gridActionsDiv.style){
                        gridActionsDiv.style.display = 'none';
                    }
                    if (routeDetailsGridActionsCustomColumnsDiv && routeDetailsGridActionsCustomColumnsDiv.style){
                        routeDetailsGridActionsCustomColumnsDiv.style.display = 'none';
                    }
                    if (proGridActionsCustomColumnsDiv && proGridActionsCustomColumnsDiv.style){
                        proGridActionsCustomColumnsDiv.style.display = 'none';
                    }
                }

                if (tabId === "routeDetailTelematic") {
                  const { equipment: { idOfObject: equipmentId }, positionSources } = Monet.Session.RouteDetail.screensList[routeId];
                  getTelematicPropertyFromEquipmentAndRenderTelematics(
                    equipmentId,
                    positionSources,
                    document.querySelector(
                      `#routeMaps_${routeId} #routeDetailTelematic`
                    ),
                    Monet.Session.RouteDetail.screensList[routeId]
                  );

                } else if (tabId === 'routeDetailChart') {

                    App.Views.RouteDetails.drawLogBook(routeId);

                } else if (tabId === 'routeDetailGrid') {

                    const proFilterBuilterElement = document.querySelector(screenTab + ' .resequenceHistory.gridActions.ui-widget-header'),
                        stopsFilterBuilderDiv = document.querySelector(screenTab + ' .stopList.gridActions.ui-widget-header');

                    if (proFilterBuilterElement && proFilterBuilterElement.style) {
                        proFilterBuilterElement.style.visibility = 'hidden';
                    }
                    if (stopsFilterBuilderDiv && stopsFilterBuilderDiv.style){
                        stopsFilterBuilderDiv.style.visibility = 'visible';
                    }

                    const gridTabName = 'RouteDetails_' + routeId;
                    const grid = App.Forms[gridTabName].table;

                    const gridStopsHandler = new Greenmile.RouteDetail.GridStops(routeId);
                    gridStopsHandler.addActionsToGrid();

                    grid.resizeCanvas();
                    grid.invalidate();

                } else if (tabId === 'routeDetailPRO') {

                    var proFilterBuilterDiv = document.querySelector(screenTab + ' .resequenceHistory.gridActions.ui-widget-header'),
                        stopsFilterBuilderDiv = document.querySelector(screenTab + ' .stopList.gridActions.ui-widget-header');

                    if (proFilterBuilterDiv && proFilterBuilterDiv.style) {
                        proFilterBuilterDiv.style.visibility = 'visible';
                    }
                    if (stopsFilterBuilderDiv && stopsFilterBuilderDiv.style){
                        stopsFilterBuilderDiv.style.visibility = 'hidden';
                    }

                    var gridTabName = `RouteDetails_${routeId}_ResequenceHistory`;

                    if(App.Forms[gridTabName] && App.Forms[gridTabName].table) {

                        var grid = App.Forms[gridTabName].table;
                        var gridResequenceHistory = App.Forms[gridTabName].gridResequenceHistory;
                        const resequenceHistoryGridHandler = new Greenmile.RouteDetail.ResequenceHistoryGrid(routeId);

                        grid.resizeCanvas();
                        grid.invalidate();
                        gridResequenceHistory.addFilterBuilder();

                        resequenceHistoryGridHandler.addActionsToGrid();

                        App.Views.RouteDetails.adjustProGridFooter();

                    } else {

                        const noResultContainer = document.createElement('div');
                        noResultContainer.classList.add('noResultContainer');
                        noResultContainer.style.marginTop = 0;
                        noResultContainer.innerHTML = Monet.I18n.getResourcesByKey('MonetUIList.noDataFound');

                        const tabDetailPRO = document.querySelector('#tabsRouteDetail #routeDetailPRO');
                        tabDetailPRO.appendChild(noResultContainer);
                    }
                }
            };

            const setHeightToElements = function (height) {

                const height2 = height - 38;

                if (grid) {
                    grid.style.height = (height2 - 57) + 'px';
                }

                if (chart) {
                    chart.style.height = height2 + "px";
                }

                if (summary) {
                    summary.style.height = height2 + "px";
                }

                if (telematic) {
                    telematic.style.height = height2 + 'px';
                }

                if (pro) {
                    pro.style.height = height2 + 'px';
                }

                App.Views.RouteDetails.setInformationStopsPosition(screenTab);

                if (legendsBottomBar) {
                    legendsBottomBar.style.bottom = `${height + 20}px`;
                }

                if (hideTab) {
                    hideTab.style.bottom = `${height + 19}px`;
                }

                if (telematic.style.display === 'block') {
                    telematicView.updateHeightElements(height2);
                }

            };

            if (tab) {

                grid = tab.querySelector('#routeDetailGrid');
                chart = tab.querySelector('#routeDetailChart');
                summary = tab.querySelector('#routeDetailSummaryInformation');
                telematic = tab.querySelector('#routeDetailTelematic');
                pro = tab.querySelector('#routeDetailPRO');

                tab.style.height = height + "px";
                tab.style.display = "block";

                if (grid) {
                    grid.style.display = 'block';
                }
                setHeightToElements(height);
            }


            if (hideTab) {
                hideTab.style.display = 'block';
            }

            $(screenTab + " #tabsRouteDetail").tabs({
                activate: function (event, ui) {

                    var tabId = ui.newPanel[0].id;

                    renderByTabId(tabId);

                }
            });

            $(screenTab + " #tabsRouteDetail").resizable({
                handles: "n",
                minHeight: minHeight,
                maxHeight: maxHeight,
                start: function () {
                    screenData.isUpdateAutomatic = false;
                },
                stop: function () {

                    let tabId;
                    const ui = arguments[1];
                    const height = ui.element.height();
                    const storage = new Greenmile.Storage.StoreMapPosition();

                    this.style.top = '';
                    this.style.width = '';

                    if (pro && pro.style.display === 'block') {
                        tabId = pro.id;
                    } else if (telematic.style.display === 'block') {
                        tabId = telematic.id;
                    } else if (chart && chart.style.display === 'block') {
                        tabId = chart.id;
                    } else if (grid.style.display === 'block') {
                        tabId = grid.id;
                    }

                    renderByTabId(tabId);
                    screenData.isUpdateAutomatic = true;
                    storage.setHeightTabsRouteDetailFromUser(height);
                    App.Views.RouteDetails.adjustHeightMap(routeId);
                },
                resize: function () {
                    var ui = arguments[1];
                    var height = ui.element.height();
                    setHeightToElements(height);
                }
            });

            this.checkShowOrHideGridPreferenceUser(routeId);
            this.addEventListenners(routeId);

            const resizeElement = $('#tabsRouteDetail > div.ui-resizable-handle.ui-resizable-n');
            $(resizeElement).append('<div class="btn-resize"><div></div></div>');

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show grid stops and log book.");
            error.console();

        }

    },

    renderGridsChoosingOrder: function (routeId, dataStops, resequenceHistoryData, inOrder) {
      const isFirstRender = Monet.Session.sessionStorage?.routeDetailFirstRender;
      if(!Monet.Session.sessionStorage.routeDetailFirstRender) {
        Monet.Session.sessionStorage.setItem("routeDetailFirstRender", false);
      }

      if(inOrder) {
        this.renderStopsGrid(routeId, dataStops, isFirstRender);
        if(resequenceHistoryData && resequenceHistoryData.length) {
          this.renderResequenceGrid(routeId, resequenceHistoryData);
        }
      } else {
        if(resequenceHistoryData && resequenceHistoryData.length) {
          this.renderResequenceGrid(routeId, resequenceHistoryData);
        }
        this.renderStopsGrid(routeId, dataStops, isFirstRender);
      }
    },

    renderGrids: function (tab, routeId, dataStops, resequenceHistoryData) {
      if (tab === 'routeDetailPRO') {
        this.renderGridsChoosingOrder(routeId, dataStops, resequenceHistoryData, true);
      }

      if(!tab || tab === 'routeDetailGrid') {
        this.renderGridsChoosingOrder(routeId, dataStops, resequenceHistoryData, false);
      }
    },

    showStopsAndLogBook: function (routeId, map, dataStops, resequenceHistoryData) {

        var error = null;

        const routeDetailScreen = Monet.Session.RouteDetail.screensList[routeId];
        const tab = routeDetailScreen ? routeDetailScreen.activeTab : null;

        try {

            this.adjustStylesToTabInformation(routeId);

            this.renderGrids(tab, routeId, dataStops, resequenceHistoryData);

            this.showLogBookAndSummaryInformation(routeId, map, "create");

            var screenTab = "#routeMaps_" + routeId;
            var proFilterBuilterDiv = document.querySelector(screenTab + ' .resequenceHistory.gridActions.ui-widget-header'),
              stopsFilterBuilderDiv = document.querySelector(screenTab + ' .stopList.gridActions.ui-widget-header');

            if(tab === "routeDetailPRO") {
                if (proFilterBuilterDiv && proFilterBuilterDiv.style) {
                    proFilterBuilterDiv.style.visibility = 'visible';
                }
                if (stopsFilterBuilderDiv && stopsFilterBuilderDiv.style){
                    stopsFilterBuilderDiv.style.visibility = 'hidden';
                }
            } else if (tab === "routeDetailGrid") {
                if (proFilterBuilterDiv && proFilterBuilterDiv.style) {
                    proFilterBuilterDiv.style.visibility = 'hidden';
                }
                if (stopsFilterBuilderDiv && stopsFilterBuilderDiv.style){
                    stopsFilterBuilderDiv.style.visibility = 'visible';
                }
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on showing grid stops and log book.", e);
            error.console();

        }
    },

    checkShowOrHideGridPreferenceUser: function (routeID) {

        var preferenceShowGrid = new Greenmile.Storage.StoreMapPosition().getShowGridRouteDetailFromUser();

        if (preferenceShowGrid) {

            if (!preferenceShowGrid.show_grid) {
                this.hideTabInformation("#routeMaps_" + routeID, routeID);
            } else {
                this.adjustHeightMap(routeID);
            }

        } else {
            // usuario ainda nao tem preferencia salva
            new Greenmile.Storage.StoreMapPosition().setShowGridRouteDetailFromUser(true);
        }
    },

    renderStopsGrid: function (routeId, dataStops, firstRender = true) {
      const stopGridHandler = new Greenmile.RouteDetail.GridStops(routeId);
      const dataMapper = new Monet.Builder.DataMapper();

      const callback = function () {
          dataMapper.copyDataMapperToAnotherNamespace(`RouteDetails_${routeId}`);
          stopGridHandler.createGrid(dataStops, { isToAddActions: firstRender });
      };

      dataMapper.setEntity('StopView');
      dataMapper.build(callback);
    },

    renderResequenceGrid: function (routeId, resequenceHistoryData) {
      const resequenceHistoryGridHandler = new Greenmile.RouteDetail.ResequenceHistoryGrid(routeId);
      const dataMapper = new Monet.Builder.DataMapper();

      const callback = function () {
          dataMapper.copyDataMapperToAnotherNamespace(`RouteDetails_${routeId}_ResequenceHistory`);
          resequenceHistoryGridHandler.createGrid(resequenceHistoryData, { isToAddActions: false });
      };

      dataMapper.setEntity('ProactiveRouteOpt');
      dataMapper.build(callback);
    },

    updateGrid: function (routeId) {

        var stopGridHandler = new Greenmile.RouteDetail.GridStops(routeId);
        stopGridHandler.createGrid();

    },

    removeGeocodeSuggest: function (routeId) {

        var container = document.querySelector("#routeMaps_" + routeId);
        var suggestionGeocodeStop = container.querySelector('.suggestGeocodeStop');

        if (suggestionGeocodeStop) {
            container.removeChild(suggestionGeocodeStop);
        }

    }

};
